<template>
  <div>
    <h5 class="text-h5 mb-4">{{ $t('product.addOn.detailsTitle') }}</h5>
    <div class="flex flex-col gap-4">
      <Card v-for="(addOn, index) in addOns" :key="addOn?.id" class="">
        <div class="flex justify-between">
          <div class="flex">
            <NuxtLazyImg
              v-if="addOn?.media?.data?.thumb"
              :src="addOn.media.data.thumb"
              class="w-16 h-16 rounded-lg object-cover"
            />
            <div v-else class="w-16 h-16 rounded-lg bg-gray-200 shrink-0" />
            <div class="flex flex-col text-left ml-4">
              <span> {{ addOn?.name }}</span>
              <span>{{
                formatPriceAmount(getEventAddOnUnitPriceAmount(addOn))
              }}</span>
            </div>
          </div>
          <IconChevronDown
            class="cursor-pointer hover:text-primary"
            :class="{
              'rotate-180': fullDescriptionVisible[index],
            }"
            @click="handleOpenDescription(index)"
          />
        </div>
        <div class="kft-review-card-body__body mt-2">
          <div
            :class="{
              'line-clamp-2': !fullDescriptionVisible[index],
            }"
            v-html="addOn?.description"
          />
        </div>
        <button
          class="pt-2 rounded-sm hover:text-primary text-sm underline"
          @click="$emit('click:addon', addOn)"
        >
          {{
            addDirectlyToCart
              ? $t('product.show.checkout.book')
              : $t('product.addOn.detailsCTA')
          }}
        </button>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconChevronDown from '~/components/icons/IconChevronDown'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(
  defineProps<{
    addOns: EventAddOn[]
    addDirectlyToCart: boolean
  }>(),
  {
    addOns: () => [],
    addDirectlyToCart: false,
  }
)
defineEmits(['click'])
const fullDescriptionVisible = ref({})
const handleOpenDescription = (index: number) => {
  const changedAddOn = { [index]: !fullDescriptionVisible.value?.[index] }
  fullDescriptionVisible.value = {
    ...fullDescriptionVisible.value,
    ...changedAddOn,
  }
}
</script>
